module.exports = MemberJoinFieldInfo;